import { ChangeDetectorRef, Component, inject, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { Leistung } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { AdminCard } from "../Sonstige/AdminCard";


@Component({
  imports: [
    CommonModule,
    Splash,
    FormsModule, AdminCard
  ],
  selector: 'LeistungEdit',
  templateUrl: './LeistungEdit.html',
  standalone: true,
  styleUrl: './LeistungEdit.css'
})
export class LeistungEdit implements OnInit {
  toastService: ToastService; 
  ngOnInit(): void {
    this.GetData();
  }
  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService)
  }
  @Input() Key?: string | null = null;

  Client: RestClient = new RestClient();

  Entry: Leistung | null = null;

  async GetData() {
    if (!this.Key || this.Key == null || this.Key == "0" || isNaN(Number(this.Key)))
      this.Entry = { key: 0 } as Leistung;
    else
      this.Entry = await this.Client.Get<Leistung>(`/Backend/Api/V2/Admin/Leistung/${this.Key}`);
    this.cdr.detectChanges();
  }

  async SaveData() {
    if (this.Entry && this.Entry !== null) {
      if (this.Entry.key == 0)
        this.Entry = await this.Client.Post<Leistung, Leistung>("/Backend/Api/V2/Admin/Leistung", this.Entry);
      else
        this.Entry = await this.Client.Put<Leistung, Leistung>(`/Backend/Api/V2/Admin/Leitstelle`, this.Entry);

      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
    }
  }
  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
